import { render, staticRenderFns } from "./myPracticeList.vue?vue&type=template&id=530004d6&scoped=true&"
import script from "./myPracticeList.vue?vue&type=script&lang=js&"
export * from "./myPracticeList.vue?vue&type=script&lang=js&"
import style0 from "./myPracticeList.vue?vue&type=style&index=0&id=530004d6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530004d6",
  null
  
)

export default component.exports